import React, { Component } from "react";
import _ from "lodash";
import { Card, CardBody } from "reactstrap";
import Fade from "react-reveal/Fade";
import { withNamespaces } from "react-i18next";
import Loader from "../../../Global/Loader";
import { Button } from "reactstrap";
import Table from "../../Components/Table";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services";
import { Icon } from "semantic-ui-react";
import { Transfer, Switch, Tooltip } from "antd";
import { Autocomplete, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";

import { withRouter } from "react-router-dom";

import TemplateForm from "./Forms/template";
import ContentWrapper from "../../../template/Layout/ContentWrapper";
import createModal from "../../Components/ModalV2";
import { openNotification } from "../../Components/Notification";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import {
  MODULES,
  MENU_HANDLER,
  RolesWithConfigurableModules,
} from "../../../Middlewares/menuConfig";

const useStyles = () => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});
class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobil: false,
      data: {},
      tableEntityConf: [
        // { label: "ID", key: "EntityId" },
        { label: "ID", key: "EntityId" },
        { label: this.props.t("company_name"), key: "Nombre" },
        { label: this.props.t("phone"), key: "Telephone" },
        { label: this.props.t("country"), key: "Country" },
      ],
      TemplateForm,
      isEdit: false,
      createFormData: "",
      generalInfo: "",
      idUsuario: this.props.match ? this.props.match.params.id : -1,
      userInfo: {
        ConfirmPassword: "********",
        Email: "",
        LastName: "",
        Name: "",
        Password: "********",
        Position: "",
        Telephone: "",
        SSOAutentication: 0,
        UserCreateId: this.props._user,
      },
      unEditedInfo: {},
      selectCatalog: {},
      camposUsuario: true,
      camposValidos: false,
      guardarDisabled: true,
      confirmPassError: false,
      loadingInfo: true,
      isEditing: false,
      isCreating: false,
      tablaClientes: "",
      loading: false,
      messageError: "",
      modalOpen: false,
      modalText: "",
      confirmCreate: false,
      action: "",
      modules: {},
      initialModules: {},
      token: this.props.token,
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMobil: isMobileDevice,
    });
    await this.getCatalogs();
    if (this.state.idUsuario > 0) {
      this.getUser();
    } else {
      this.setState({ loadingInfo: false }, () => {
        this.renderForm(false);
      });
    }

    document.body.classList.add("transfer-select-all-only");
  };

  componentWillUnmount() {
    document.body.classList.remove("transfer-select-all-only");
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      newSelected: [],
      selectcheck: false,
      Form: nextProps.form,
      reset: true,
    });
  };

  handleChangeDrop = (attribute, isEdit) => (evt, data) => {
    let { userInfo, showClientes, guardarDisabled } = this.state;
    const configurable = RolesWithConfigurableModules[data.value];

    if (configurable) {
      const defaultModules = configurable.reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {});
      this.setState({ modules: defaultModules });
    }

    let campo = data ? data.value : null;
    userInfo[attribute] = campo;

    if (attribute === "RoleId") {
      userInfo.Entities = [];
      userInfo.suppliers = [];
      userInfo.companiesToCustomers = [];
      userInfo.companiesToSupplier = [];

      showClientes = ![1, 2].includes(data.value);

      guardarDisabled = !this.validarCampos(isEdit);
    } else if (attribute === "Reportes") {
      if (data && data.length > 0) {
        userInfo[attribute] = data.map((value) => value.value);
      } else {
        userInfo[attribute] = [];
      }
    }

    this.setState({ userInfo, showClientes, guardarDisabled }, () => {
      this.renderForm(isEdit);
    });
  };

  handleChangeFilter = (campo, isEdit) => (nextTargetKeys) => {
    const cleanedKeys = [
      ...new Set(nextTargetKeys.filter((v) => v != null && v !== "")),
    ];

    this.setState((prevState) => {
      const newUserInfo = { ...prevState.userInfo, [campo]: cleanedKeys };

      const guardarDisabled = !(
        [1, 2].includes(newUserInfo["RoleId"]) || cleanedKeys.length > 0
      );

      return {
        userInfo: newUserInfo,
        guardarDisabled,
      };
    });
  };

  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      html: `<div class="text-center euro-title-form">
      ${text}
      </div>`,
      customClass: {
        confirmButton: "custom-width-btn swal",
      },
    });
  };

  editarInformacionAlta = () => {
    this.setState({ showClientes: false, camposUsuario: true }, () => {
      this.renderForm(false);
    });
  };

  findEntityIds = (catalog, userEntities) => {
    if (typeof userEntities !== "string" || !userEntities.trim()) return [];

    const userEntitiesSet = new Set(userEntities.split(","));

    return catalog
      .filter((cat) => userEntitiesSet.has(cat.data.CodeEP))
      .map((cat) => cat.data.EntityId);
  };

  getUser = async () => {
    try {
      const { data } = await axios.get(
        `${Services.ADMIN.path}admin/getInfoUser/${this.state.idUsuario}`,
      );

      const user = data.user?.[0];
      if (!user) throw new Error("No se encontró el usuario");

      const moduleIds = user.ModulesIds
        ? user.ModulesIds.split(",").map(Number)
        : [];

      const configurable = RolesWithConfigurableModules[user.RoleId] || [];

      const defaultModules = configurable.reduce((acc, key) => {
        const moduleId = MODULES[key]?.id;
        if (moduleId !== undefined) {
          acc[key] = moduleIds.includes(moduleId);
        }
        return acc;
      }, {});

      const entities = this.findEntityIds(
        this.state.selectCatalog["Entities"],
        user.EntitiesIds,
      );

      const suppliers = this.findEntityIds(
        this.state.selectCatalog["suppliers"],
        user.EntitiesSIds,
      );

      const companiSuppliers = this.findEntityIds(
        this.state.selectCatalog["companiesToSupplier"],
        user.EntitiesSIdcs,
      );

      const reportes = this.parsearArrayInt(user.ReportsIds?.split(",") || []);

      const reportsNames = this.obtenerNombreReportes(reportes);

      const userInfo = {
        ...user,
        Entities: entities,
        Reportes: reportes,
        ReportsNames: reportsNames,
        ConfirmPassword: "",
        Password: "",
        suppliers: suppliers,
        companiesToSupplier: companiSuppliers,
        companiesToCustomers: entities,
      };

      this.setState(
        {
          userInfo,
          isEdit: true,
          tablaClientes: this.obtenerTablaClientes({
            entities,
            suppliers,
            companiSuppliers,
            roleId: user.RoleId,
          }),
          unEditedInfo: _.cloneDeep(userInfo),
          loadingInfo: false,
          modules: { ...defaultModules },
          initialModules: { ...defaultModules },
        },
        () => {
          this.renderForm(true);
          this.generarInfoGeneral();
        },
      );
    } catch (error) {
      console.warn(error);
    }
  };

  parsearArrayInt = (arr) => {
    let intArr = [];
    arr.map((s) => {
      intArr.push(parseInt(s));
    });
    return intArr;
  };

  obtenerTablaClientes = ({
    entities = [],
    suppliers = [],
    companiSuppliers = [],
    roleId,
  }) => {
    const buildTable = (idsArray, catalogKey) => {
      const catalogMap = new Map(
        this.state.selectCatalog[catalogKey].map((ent) => [
          String(ent.data.EntityId),
          ent.data,
        ]),
      );

      const arrayEntity = idsArray
        .map((entId) => catalogMap.get(String(entId)))
        .filter(Boolean)
        .sort((a, b) => a.Nombre.localeCompare(b.Nombre));

      return (
        <Table
          columns={this.state.tableEntityConf}
          data={arrayEntity}
          itemsByPage={5}
          rowClick={false}
          options={{
            large: true,
            downloads: {
              pdf: false,
              xlsx: false,
            },
            pagination: true,
            search: true,
          }}
        />
      );
    };

    if (roleId === 9) {
      return (
        <div className="tablas-usuario-multiples">
          <h4 className="euro-title-form">
            {this.props.t("admin_users_associate_suppliers_detail")}
          </h4>
          {buildTable(suppliers, "suppliers")}

          <h4 className="euro-title-form">
            {this.props.t("admin_users_associate_companies_to_supplier_detail")}
          </h4>
          {buildTable(companiSuppliers, "companiesToSupplier")}

          <h4 className="euro-title-form">
            {this.props.t(
              "admin_users_associate_companies_to_customers_detail",
            )}
          </h4>
          {buildTable(entities, "Entities")}
        </div>
      );
    }

    if (roleId === 8) {
      return (
        <div className="tablas-usuario-multiples">
          <h4 className="euro-title-form">
            {this.props.t("admin_users_associate_suppliers_detail")}
          </h4>
          {buildTable(suppliers, "suppliers")}

          <h4 className="euro-title-form">
            {this.props.t("admin_users_associate_companies_to_supplier_detail")}
          </h4>
          {buildTable(companiSuppliers, "companiesToSupplier")}
        </div>
      );
    }

    return buildTable(entities, "Entities");
  };

  obtenerNombreReportes = (ReportsIds) => {
    let ReportsName = [];
    if (ReportsIds && ReportsIds.length > 0) {
      ReportsIds.map((id) => {
        this.state.selectCatalog["Reportes"].map((reporte) => {
          if (id === reporte.key) {
            ReportsName.push(reporte.text);
          }
        });
      });
    }
    return ReportsName;
  };
  sortCatalogs = (array, attr) => {
    array.sort((a, b) => a[attr].localeCompare(b[attr]));
    return array;
  };

  sortEntityCatalogs = (array, attr) => {
    array.sort((a, b) => a.data[attr].localeCompare(b.data[attr]));
    return array;
  };

  getCatalogs = async () => {
    try {
      const { selectCatalog } = this.state;

      const response = await axios.get(`${Services.ADMIN.path}admin/catalogs`);

      const {
        reportes,
        roles,
        entitiesdb,
        suppliers,
        companiesToSupplier,
        companiesToCustomers,
        biLicenses,
      } = response.data;

      const biLicensesOptions = [
        { value: "none", key: "none", text: this.props.t("none_option") },
        ...biLicenses,
      ];

      const updatedCatalog = {
        ...selectCatalog,
        Reportes: this.sortCatalogs(reportes, "text"),
        Roles: this.sortCatalogs(roles, "text"),
        biLicenses: biLicensesOptions,
        Entities: entitiesdb,
        EntitiesDB: entitiesdb,
        suppliers,
        companiesToCustomers,
        companiesToSupplier,
      };

      this.setState({ selectCatalog: updatedCatalog }, () => {
        this.renderForm();
      });
    } catch (error) {
      console.warn("Error fetching catalogs:", error);
    }
  };

  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  handleChange = (name, isEdit) => (event) => {
    let { userInfo, errorPass, confirmPassError, guardarDisabled } = this.state;
    name === "Email"
      ? (userInfo[name] = event.target.value.toLowerCase())
      : (userInfo[name] = event.target.value);
    if (name === "Password" || name === "ConfirmPassword") {
      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/,
      );
      let pass = userInfo["Password"] ? userInfo["Password"] : "";
      if (emailRegex.test(pass)) {
        errorPass = false;
      } else {
        errorPass = true;
      }

      if (userInfo["ConfirmPassword"] !== userInfo["Password"]) {
        confirmPassError = true;
      } else {
        confirmPassError = false;
      }
      if (isEdit === true) {
        if (userInfo["ConfirmPassword"] === "" && userInfo["Password"] === "") {
          camposValidos = true;
          errorPass = false;
        } else {
          camposValidos = !confirmPassError && !errorPass;
        }
      } else {
        camposValidos = !confirmPassError && !errorPass;
      }
    }
    if (!confirmPassError && !errorPass) {
      var camposValidos = this.validarCampos(isEdit);
    }

    if (isEdit) {
      guardarDisabled = !camposValidos;
    }

    this.setState(
      { userInfo, errorPass, camposValidos, confirmPassError, guardarDisabled },
      () => this.renderForm(isEdit),
    );
  };

  validarCampos = (isEdit) => {
    let { userInfo } = this.state;
    var campos = TemplateForm[isEdit ? "editUser" : "createUser"];
    var valido = true;
    campos.map((campo) => {
      if (campo.required) {
        if (!userInfo[campo.id] || userInfo[campo.id] === "") {
          valido = false;
        }
      }
    });
    var flagEntities = false;
    if (isEdit) {
      if ([1, 2].indexOf(userInfo.RoleId) >= 0) {
        flagEntities = true;
      } else {
        flagEntities = userInfo.Entities && userInfo.Entities.length > 0;
      }
    } else {
      flagEntities = true;
    }

    return valido && flagEntities;
  };

  recieve = (array) => {
    this.setState({
      newSelected: array,
    });
  };

  dataReport = (data, edit) => {
    let dataReport = { data: data, userId: this.props._user };

    this.setState({
      dataReport,
    });
  };
  viewPass = (isEdit) => {
    let { viewpass, TemplateForm } = this.state;
    for (
      let i = 0;
      i < TemplateForm[isEdit ? "editUser" : "createUser"].length;
      i++
    ) {
      const e = TemplateForm[isEdit ? "editUser" : "createUser"][i];
      if (e.id === "ConfirmPassword" || e.id === "Password") {
        e.datatype = viewpass ? "" : "Password";
      }
    }
    this.setState({ TemplateForm }, () => {
      this.renderForm(isEdit);
    });
  };

  handlePriorityChange = (event, id, isEdit) => {
    let ssoValue = event;

    let { userInfo, guardarDisabled } = this.state;
    userInfo[id] = ssoValue ? 1 : 0;
    guardarDisabled = !this.validarCampos(isEdit);
    this.setState({ userInfo, guardarDisabled }, () => {
      this.renderForm(isEdit);
    });
  };

  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  renderForm = (isEdit) => {
    let {
      TemplateForm,
      userInfo,
      selectCatalog,
      confirmPassError,
      showCatalogModal,
      viewpass,
      preview,
      errorPass,
    } = this.state;
    const { classes } = this.props;
    let createFormData = TemplateForm[isEdit ? "editUser" : "createUser"].map(
      (e) => {
        if (e.type === "Input")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  <label className={"euro-input-label"}>
                    {this.props.t(e.label)}{" "}
                    {e.required === true ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                </span>
              </Fade>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "3px",
                }}
              >
                <TextField
                  // label={e.placeHolder}
                  placeholder={this.props.t(e.placeHolder)}
                  title={this.props.t("fill_field")}
                  variant="standard"
                  type={e.datatype}
                  name={e.id}
                  value={userInfo[e.id]}
                  maxlength={e.maxlength}
                  minlength={e.minlength}
                  className={e.id === "Email" ? "email-lower" : ""}
                  InputProps={{
                    classes: {
                      input: "input-euro",
                    },
                  }}
                  onFocus={(e) => {
                    e.target.setAttribute("autocomplete", "none");
                  }}
                  autoComplete="new-password"
                  onChange={this.handleChange(
                    e.id,
                    isEdit ? true : false,
                    e.validation,
                  )}
                  max={e.max}
                  disabled={e.disabled ? e.disabled : false}
                />
              </div>
              {!preview && errorPass && e.id === "Password" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>
                      {this.props.t("pass_structure")}
                      <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
                        {this.props.t("extended_rule_pass")}
                      </p>
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
              {!preview && confirmPassError && e.id === "ConfirmPassword" ? (
                <div style={{ width: "100%" }}>
                  <div
                    id="pass_diferentes"
                    style={{ marginTop: "10px", fontSize: "smaller" }}
                    className="col-12"
                  >
                    <label>{this.props.t("password_not_match")}</label>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        else if (e.type === "Select") {
          let defaultval = selectCatalog[e.selectCatalogName]
            ? selectCatalog[e.selectCatalogName].find((cat) => {
                return cat.value == userInfo[e.id];
              })
            : {};

          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={e.id} style={e.style}>
                  {" "}
                  <label className={"euro-input-label"}>
                    {this.props.t(e.label)}{" "}
                    {e.required ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}{" "}
                  </label>
                </span>
              </Fade>
              <Autocomplete
                closeText={false}
                openText={false}
                style={{ marginTop: "6px" }}
                id="size-small-standard"
                className="search-drops"
                size="small"
                value={defaultval}
                defaultValue={defaultval}
                isOptionEqualToValue={(a, b) => {
                  return a.value == b.value;
                }}
                ListboxProps={{
                  sx: { fontSize: 12 },
                }}
                sx={{
                  "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                    fontSize: 12,
                  },
                }}
                options={
                  selectCatalog[e.selectCatalogName]
                    ? selectCatalog[e.selectCatalogName]
                    : []
                }
                getOptionLabel={(option) => option.text}
                onChange={this.handleChangeDrop(e.id, isEdit)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    className={classes.textfield}
                  />
                )}
              />

              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        }
        if (e.type === "Switch")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  <label className={"euro-input-label"}>
                    {this.props.t(e.label)}{" "}
                    {e.required === true ? (
                      <span style={{ color: "#ff0000" }}>*</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <Switch
                    className="form-input-switch"
                    checked={Number(userInfo[e.id])}
                    onChange={(event) => {
                      this.handlePriorityChange(
                        event,
                        e.id,
                        isEdit ? true : false,
                      );
                    }}
                  ></Switch>
                </span>
              </Fade>
            </div>
          );
        else
          return (
            <div
              className={e.class}
              style={{ marginTop: "20px" }}
              key={e.id}
            ></div>
          );
      },
    );
    this.setState({
      createFormData,
      showCatalogModal,
      userInfo,
      isEdit,
    });
  };

  generarInfoGeneral = () => {
    const { userInfo, isEdit, isCreating, selectCatalog } = this.state;
    let showClientes = this.state.showClientes;

    const generalInfo = TemplateForm["previewForm"]
      .filter(({ id }) => !(isCreating && id === "UserCreate"))
      .map((item, index) => {
        const { id, type, label, class: cssClass, selectCatalogName } = item;

        let content = null;

        switch (type) {
          case "label":
            const isSSO = id === "SSOAutentication";
            content = (
              <span className="label-euro">
                {isSSO
                  ? userInfo[id] === 1 || userInfo[id] === "1"
                    ? this.props.t("activated_soo")
                    : this.props.t("disabled_soo")
                  : userInfo[id]}
              </span>
            );
            break;

          case "list":
            content = (
              <span className="label-euro">
                {Array.isArray(userInfo[id]) ? userInfo[id].length : 0}
              </span>
            );
            break;

          case "select":
            const catalog = selectCatalog[selectCatalogName] || [];
            const selected = catalog.find((c) => c.key === userInfo[id]);
            content = (
              <span className="label-euro">
                {selected ? selected.text : ""}
              </span>
            );
            break;

          case "password":
            if (isEdit) return null;
            content = <span className="label-euro">***********</span>;
            break;

          default:
            return null;
        }

        return (
          <div key={index} className={cssClass} style={{ paddingTop: "1%" }}>
            <div className="row">
              <div className="col-md-12 col-lg-12 col-sm-6">
                <span className="label-euro" style={{ fontWeight: "bold" }}>
                  {this.props.t(label)}
                </span>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-6">{content}</div>
            </div>
          </div>
        );
      });

    if (!isEdit) {
      showClientes = true;
    }

    const roleId = userInfo["RoleId"];
    const hasEntities = userInfo.Entities && userInfo.Entities.length > 0;

    const hasSuppliers =
      Array.isArray(userInfo.suppliers) && userInfo.suppliers.length > 0;
    const hasCompaniesToCustomers =
      Array.isArray(userInfo.companiesToCustomers) &&
      userInfo.companiesToCustomers.length > 0;
    const hasCompaniesToSupplier =
      Array.isArray(userInfo.companiesToSupplier) &&
      userInfo.companiesToSupplier.length > 0;

    let guardarDisabled;

    if ([1, 2].includes(roleId)) {
      guardarDisabled = false;
    } else if (roleId === 8) {
      guardarDisabled = !(hasSuppliers && hasCompaniesToSupplier);
    } else if (roleId === 9) {
      guardarDisabled = !(
        hasSuppliers &&
        hasCompaniesToCustomers &&
        hasCompaniesToSupplier
      );
    } else {
      guardarDisabled = !hasEntities;
    }

    if ([1, 2].includes(roleId)) {
      showClientes = false;
    }

    this.setState({
      camposUsuario: false,
      showClientes,
      guardarDisabled,
      generalInfo,
    });
  };

  confirmaGuardado = () => {
    const { isEdit } = this.state;
    const mensaje = this.props.t(
      isEdit ? "sure_edit_user" : "sure_create_user",
    );

    this.setState({
      confirmCreate: true,
      modalText: mensaje,
      typeAlert: "success",
      action: isEdit ? this.PutUser : this.saveUser,
    });
  };

  buildFinalModules() {
    const { userInfo, modules } = this.state;
    const roleId = userInfo.RoleId;

    const defaultModules = MENU_HANDLER[roleId] || [];
    const configurables = RolesWithConfigurableModules[roleId] || [];

    const activeConfigurableModules = configurables.filter(
      (key) => modules[key],
    );

    const filteredModules = [
      ...defaultModules.filter((m) => !configurables.includes(m)),
      ...activeConfigurableModules,
    ];

    const finalModuleIds = filteredModules
      .map((key) => MODULES[key]?.id)
      .filter((id) => id !== undefined);

    return finalModuleIds;
  }

  saveUser = async () => {
    let { userInfo, token } = this.state;

    userInfo.Email = userInfo.Email.toLowerCase();
    userInfo.Password = "xpdG2030@";
    userInfo.ConfirmPassword = "xpdG2030@";

    const finalModules = this.buildFinalModules();
    userInfo.Modules = finalModules;

    const data = { data: userInfo };

    try {
      let url = `${Services.ADMIN.path}admin/createUser`;
      await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState({
        loadingInfo: false,
        confirmCreate: false,
        modalOpen: true,
        modalText: this.props.t("user_save_success"),
        typeAlert: "success",
        action: () => this.props.history.push("users"),
      });
    } catch (error) {
      const { code, user, message } = error?.response?.data || {};
      this.setState({ loadingInfo: false, confirmCreate: false });

      if (code === "user_deleted") {
        this.setState({
          modalOpen: true,
          typeAlert: "error",
          action: async () => {
            this.setState({ loadingInfo: true, modalOpen: false });

            try {
              await axios.put(`${Services.ADMIN.path}admin/activateUser`, {
                data: { UserId: user },
              });

              this.setState({
                loadingInfo: false,
                modalOpen: true,
                modalText: this.props.t("user_updated_successfully"),
                typeAlert: "success",
                action: () => {
                  this.props.history.push(`/user-detail/${user}`);
                  window.location.reload();
                },
              });
            } catch (err) {
              this.setState({
                loadingInfo: false,
                modalOpen: true,
                modalText: this.props.t(
                  err?.response?.data?.message || "error",
                ),
                typeAlert: "error",
                action: () => this.setState({ modalOpen: false }),
              });
            }
          },
        });
      } else if (code === "email_exist") {
        this.setState({
          modalOpen: true,
          modalText: this.props.t("email_in_use"),
          typeAlert: "success",
          action: () => {
            this.props.history.push(`/user-detail/${user}`);
            window.location.reload();
          },
        });
      } else {
        const finalMessage = message?.includes("Required fields:")
          ? message.replace(
              "Required fields:",
              this.props.t("required_fields") + ": ",
            )
          : this.props.t(message);

        this.setState({
          modalOpen: true,
          modalText: this.props.t(finalMessage || "error"),
          typeAlert: "error",
          action: () => this.setState({ modalOpen: false }),
        });
      }
    }
  };

  cambiaEdicion = () => {
    let { showClientes } = this.state;
    if ([1, 2].indexOf(this.state.userInfo.RoleId) >= 0) {
      showClientes = false;
    } else {
      showClientes = true;
    }
    this.setState(
      {
        isEditing: true,
        camposUsuario: true,
        showClientes,
        guardarDisabled: false,
      },
      () => {
        this.renderForm(true);
      },
    );
  };

  cancelarEdicion = () => {
    let { showClientes, unEditedInfo } = this.state;
    if ([1, 2].indexOf(this.state.userInfo.RoleId) >= 0) {
      showClientes = false;
    } else {
      showClientes = true;
    }
    this.setState(
      {
        userInfo: _.cloneDeep(unEditedInfo),
        isEditing: false,
        camposUsuario: false,
        showClientes: false,
        modules: { ...this.state.initialModules },
      },
      () => {
        this.generarInfoGeneral();
      },
    );
  };

  PutUser = async () => {
    let { userInfo, token } = this.state;
    userInfo.Email = userInfo.Email.toLowerCase();
    const finalModules = this.buildFinalModules();
    userInfo.Modules = finalModules;

    const { UserCreateId, UserCreate, ...cleanedUserInfo } = userInfo;
    const data = { data: cleanedUserInfo };

    this.setState({ loadingInfo: true });

    try {
      let url = `${Services.ADMIN.path}admin/updateUser`;
      await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState({
        loadingInfo: false,
        confirmCreate: false,
        modalOpen: true,
        modalText: this.props.t("user_update_success"),
        typeAlert: "success",
        action: () => this.props.history.push("/users"),
      });
    } catch (error) {
      const rawMsg =
        error?.response?.data?.data?.message ||
        error?.response?.data?.message ||
        "error";
      const finalMsg = rawMsg.includes("Required fields:")
        ? rawMsg.replace(
            "Required fields:",
            this.props.t("required_fields") + ": ",
          )
        : rawMsg;

      this.setState({
        loadingInfo: false,
        confirmCreate: false,
        modalOpen: true,
        modalText: this.props.t(finalMsg),
        typeAlert: "error",
        action: () => this.setState({ modalOpen: false }),
      });
    }
  };

  validateSaveUser = (e) => (evt) => {
    let validation = [];
    let errors = [];
    let Forms = TemplateForm.createUser;

    Forms.map((e) => {
      if (e.required === true) {
        validation.push(e);
      }
      return e;
    });
    validation.forEach((e) => {
      if (!this.state.userInfo[e.id] || this.state.userInfo[e.id] === "") {
        errors.push(this.props.t(e.label));
        document.getElementById(e.id).style.color = "red";
      } else {
        document.getElementById(e.id).style.color = "black";
      }
    });
    if (errors.length > 0) {
      let messageErr =
        this.props.t("required_fields") + ": " + errors.join(", ") + "";
      if (messageErr !== this.state.messageError) {
        this.setState({ messageError: messageErr });
        openNotification(
          "error",
          this.props.t("required_fields") + ": " + errors.join(", ") + "",
        );
      }
    } else {
      if (!this.state.confirmPassError) {
        this.generarInfoGeneral();
      } else {
        openNotification("error", this.props.t("password_not_equal"));
      }
    }
  };

  // filterOption = (a, b, c) => {
  //   return b.label.toLowerCase().indexOf(a.toLowerCase()) > -1;
  // };

  filterOption = (inputValue, item) => {
    const search = inputValue.toLowerCase();

    const label = (item.label || "").toLowerCase();
    const ownerTeam = (item.data?.OwnerTeam || "").toLowerCase();
    const codeEP = (item.data?.CodeEP || "").toLowerCase();

    return (
      label.includes(search) ||
      ownerTeam.includes(search) ||
      codeEP.includes(search)
    );
  };

  getValuesReports = () => {
    let { userInfo } = this.state;
    let arrayValues = [];
    this.state.selectCatalog["Reportes"].map((cat) => {
      userInfo["Reportes"].map((reporte) => {
        if (cat.value == reporte) {
          arrayValues.push(cat);
        }
      });
    });
    return arrayValues;
  };

  sendNotification = async () => {
    let { userInfo, loading } = this.state;
    this.setState({ loading: true });
    let data = {
      data: {
        Name: userInfo.Name,
        LastName: userInfo.LastName,
        RoleId: userInfo.RoleId,
        Email: userInfo.Email,
        SendToAllRoles: true,
      },
    };

    let url = `${Services.ADMIN.path}admin/notification-new-user`;
    let res = await axios.post(url, data);
    if (res.status === 200) {
      this.setState({
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  handleToggle = (moduleKey) => {
    this.setState((prevState) => ({
      modules: {
        ...prevState.modules,
        [moduleKey]: !prevState.modules[moduleKey],
      },
    }));
  };

  renderAccessControlModule() {
    const { modules, userInfo, camposUsuario, isEditing, isEdit } = this.state;

    const configurable = RolesWithConfigurableModules[userInfo.RoleId];

    const mostrarModulos = !camposUsuario || (isEditing && camposUsuario);

    if (!configurable || !mostrarModulos) return null;

    const isVistaPrevia = !camposUsuario && !isEditing && isEdit;

    return (
      <div className="mt-3">
        <div className="module-access">
          <span className="euro-title-form">
            {this.props.t("admin_users_create_user_access_control_module")}
          </span>
          {!isVistaPrevia && (
            <span
              className="icon-tooltip icons-front-module"
              title={this.props.t(
                "admin_users_create_user_access_control_module_tooltip",
              )}
            />
          )}
        </div>
        <hr className="hr-euro-blue" />

        <div style={{ display: "flex", flexDirection: "column" }}>
          {configurable.map((key) => {
            const config = MODULES[key];
            const iconClass = config?.icon || "";
            const label = this.props.t(config?.name) || key;

            return (
              <FormControlLabel
                key={key}
                label={
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {iconClass && (
                      <span className={iconClass + " icons-front-module"} />
                    )}
                    {label}
                  </Box>
                }
                control={
                  <Checkbox
                    checked={Boolean(modules[key])}
                    onChange={() => this.handleToggle(key)}
                    disabled={isVistaPrevia}
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: 28 },
                      color: isVistaPrevia ? "#A0A0A0" : "#000a2e",
                      "&.Mui-checked": {
                        color: isVistaPrevia ? "#A0A0A0" : "#000a2e",
                      },
                    }}
                  />
                }
                sx={{
                  color: "#000a2e",
                  fontWeight: "bold",
                  "& .MuiTypography-root": {
                    fontSize: 12,
                    fontWeight: "bold",
                    fontFamily: "SF Pro Display",
                  },
                  fontFamily: "SF Pro Display",
                  margin: 0,
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }

  renderTransferCompanias() {
    const { showClientes, camposUsuario, isEdit, isEditing } = this.state;

    const mostrarTransfer =
      showClientes && (!camposUsuario || (isEdit && isEditing));

    if (!mostrarTransfer) return null;

    return (
      <div className="col-12" style={{ marginTop: "5%" }}>
        <div style={{ marginTop: "50px", marginBottom: "25px" }}>
          <h4 className="euro-title-form">
            {this.props.t("associate_companies")}
          </h4>
          <p style={{ color: "#BA2B30", fontSize: "smaller" }}>
            {this.props.t("at_least_company")} *
          </p>
        </div>

        {this.renderTransferByRole()}
      </div>
    );
  }

  renderTransferByRole() {
    const { t } = this.props;
    const { userInfo, isEdit, selectCatalog } = this.state;
    const roleId = userInfo.RoleId;

    const renderTransfer = (label, sourceKey, targetKey, locale) => (
      <div style={{ marginBottom: "25px" }}>
        <h4 className="euro-title-form">{t(label)}</h4>
        <Transfer
          locale={{
            itemUnit: t(locale),
            itemsUnit: t(locale),
            searchPlaceholder: "",
            selectAll: t("select_all_data"),
            selectCurrent: t("select_current_page"),
            selectInvert: t("invert_current_page"),
          }}
          dataSource={selectCatalog[sourceKey]}
          showSearch
          filterOption={this.filterOption}
          onChange={this.handleChangeFilter(sourceKey, isEdit)}
          pagination
          showSelectAll
          render={(item) => (
            <span>
              {t(item.label)} <span>({item.data.OwnerTeam})</span>
              <span
                style={{
                  marginLeft: "6px",
                  color: "#9E9E9E",
                  fontSize: "11px",
                }}
              >
                Id: {item.data.CodeEP}
              </span>
            </span>
          )}
          targetKeys={userInfo[targetKey]}
          operations={[t("associate"), t("eliminate")]}
        />
      </div>
    );

    if (roleId === 8) {
      return (
        <>
          {renderTransfer(
            "admin_users_associate_suppliers",
            "suppliers",
            "suppliers",
            "admin_users_associate_suppliers_detail",
          )}
          {renderTransfer(
            "admin_users_associate_companies_to_supplier",
            "companiesToSupplier",
            "companiesToSupplier",
            "admin_users_associate_companies_to_supplier_detail",
          )}
        </>
      );
    }

    if (roleId === 8 || roleId === 9) {
      return (
        <>
          {renderTransfer(
            "admin_users_associate_suppliers",
            "suppliers",
            "suppliers",
            "admin_users_associate_suppliers_detail",
          )}
          {renderTransfer(
            "admin_users_associate_companies_to_supplier",
            "companiesToSupplier",
            "companiesToSupplier",
            "admin_users_associate_companies_to_supplier_detail",
          )}
          {renderTransfer(
            "admin_users_associate_companies_to_customers",
            "companiesToCustomers",
            "companiesToCustomers",
            "admin_users_associate_companies_to_customers_detail",
          )}
        </>
      );
    }
    return renderTransfer("associate_companies", "Entities", "Entities");
  }

  renderBotonesGuardarCancelar() {
    const { t } = this.props;
    const { isEdit, isEditing, camposUsuario, isMobil, guardarDisabled } =
      this.state;

    const mostrarBotones = (!camposUsuario && !isEdit) || (isEdit && isEditing);

    if (!mostrarBotones) return null;

    return (
      <div className="col-12 row d-flex justify-content-end pt-3">
        {!isEdit && (
          <Button
            color="secondary"
            className="custom-width-btn float-right m-1"
            onClick={this.editarInformacionAlta}
          >
            {t("back")}
          </Button>
        )}

        {!isMobil ? (
          <Button
            disabled={guardarDisabled}
            color="primary"
            className="custom-width-btn float-right m-1"
            onClick={this.confirmaGuardado}
          >
            {t("save")}
          </Button>
        ) : (
          <div className="col-xs-6 pr-1">
            <Button
              block
              variant="contained"
              disabled={guardarDisabled}
              color="primary"
              className="button float-right"
              onClick={this.confirmaGuardado}
            >
              {t("save")}
            </Button>
          </div>
        )}

        {isEdit &&
          isEditing &&
          (!isMobil ? (
            <Button
              color="secondary"
              className="custom-width-btn float-right m-1"
              onClick={this.cancelarEdicion}
            >
              {t("cancel")}
            </Button>
          ) : (
            <div className="col-xs-6">
              <Button
                block
                variant="contained"
                style={{ backgroundColor: "#000a2e" }}
                color="secondary"
                className="button float-right"
                onClick={this.cancelarEdicion}
              >
                {t("cancel")}
              </Button>
            </div>
          ))}
      </div>
    );
  }

  renderTablaClientes() {
    const { isEdit, isEditing, tablaClientes } = this.state;
    if (!isEdit || isEditing) return null;

    return <div className="col-12">{tablaClientes}</div>;
  }

  render() {
    let {
      loadingInfo,
      isEditing,
      isEdit,
      loading,
      camposUsuario,
      modalOpen,
      modalText,
      typeAlert,
      confirmCreate,
      action,
      modules,
    } = this.state;
    const { classes } = this.props;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-organizations icon-header" />
          {this.props.t("admin_users")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/users")}
              />
            </Icon.Group>
            <span
              className="label-back"
              onClick={() => this.props.history.push("/users")}
            >
              {this.props.t("back")}
            </span>
          </div>
        </div>
        <Card className="myCard">
          <CardBody>
            <div className="col-12">
              <span className="euro-title-form">{this.props.t("users")}</span>
              <hr className="hr-euro-blue"></hr>
            </div>
            <div className="col-12 pb-5">
              {this.state.camposUsuario ? (
                <div>
                  <span className="euro-title-form">
                    {" "}
                    {isEdit
                      ? this.props.t("user_edition")
                      : this.props.t("new_user")}
                  </span>
                  <div className="row">{this.state.createFormData}</div>
                </div>
              ) : (
                <div>
                  <div className="row">
                    <div className="col-8">
                      <span className="euro-title-form">
                        {this.state.isEdit
                          ? this.props.t("user_detail")
                          : this.props.t("user_information")}
                      </span>
                    </div>
                    <div className="ml-auto">
                      {isEdit && !isEditing ? (
                        <span
                          className="icon-edit icons-front-module"
                          onClick={() => this.cambiaEdicion()}
                          title={this.props.t("edit")}
                        ></span>
                      ) : (
                        false
                      )}
                    </div>
                  </div>
                  <div className="row">{this.state.generalInfo}</div>
                </div>
              )}
              {!camposUsuario && isEdit ? (
                <div
                  className="mt-3 d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={this.sendNotification}
                >
                  <i
                    className={
                      loading
                        ? "fas fa-sync fa-spin fa-2x mr-3"
                        : "icon-email icons-front-module"
                    }
                  ></i>
                  {this.props.t("send_notification")}
                </div>
              ) : (
                ""
              )}

              {this.renderAccessControlModule()}

              {this.state.isEdit ? (
                <div style={{ marginTop: "50px", marginBottom: "25px" }}>
                  <h4 className="euro-title-form">
                    {this.props.t("assigned_reports")}
                  </h4>
                </div>
              ) : (
                false
              )}
              <div className="row">
                <div className="col-xs-12 col-md-4 col-lg4">
                  {isEdit && !isEditing ? (
                    <div className="row">
                      <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                        <span className={"euro-input-label"}>
                          {this.props.t("report")}
                        </span>
                      </div>
                      <div className={"col-md-12 col-lg-12 col-sm-6 "}>
                        {this.state.userInfo.ReportsIds
                          ? this.state.userInfo.ReportsNames.join(", ")
                          : ""}
                      </div>
                    </div>
                  ) : isEdit ? (
                    <div className="input-form">
                      <Fade left opposite>
                        <label className={"euro-input-label"}>
                          {this.props.t("report")}{" "}
                        </label>
                      </Fade>
                      <Autocomplete
                        closeText={false}
                        openText={false}
                        multiple={true}
                        style={{ marginTop: "6px" }}
                        id="size-small-standard"
                        className="search-drops"
                        size="small"
                        ListboxProps={{
                          sx: { fontSize: 12 },
                        }}
                        sx={{
                          "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                            fontSize: 12,
                          },
                        }}
                        options={
                          this.state.selectCatalog["Reportes"]
                            ? this.state.selectCatalog["Reportes"]
                            : []
                        }
                        getOptionLabel={(option) => option.text}
                        onChange={this.handleChangeDrop(
                          "Reportes",
                          this.state.isEdit,
                        )}
                        defaultValue={
                          this.state.userInfo["Reportes"]
                            ? this.getValuesReports()
                            : []
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className={classes.textfield}
                          />
                        )}
                      />
                    </div>
                  ) : (
                    false
                  )}
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-12 col-lg-12 row d-flex justify-content-end">
              {!isEdit ? (
                this.state.camposUsuario ? (
                  <>
                    <div className="col-xs-12 col-md-3 col-lg-2 pb-1">
                      <Button
                        block
                        variant="contained"
                        style={{
                          backgroundColor: "red",
                          marginRight: "10px",
                        }}
                        color="secondary"
                        onClick={() => this.props.history.push("/users")}
                      >
                        {this.props.t("cancel")}
                      </Button>
                    </div>
                    <div className="col-xs-12 col-md-3 col-lg-2 pb-1">
                      <Button
                        block
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          this.setState(
                            { isCreating: true },
                            this.validateSaveUser(),
                          );
                        }}
                      >
                        {this.props.t("next")}
                      </Button>
                    </div>
                  </>
                ) : (
                  false
                )
              ) : (
                false
              )}
            </div>
            {this.renderTransferCompanias()}
            {this.renderBotonesGuardarCancelar()}
            {this.renderTablaClientes()}
          </CardBody>
        </Card>
        {createModal({
          isModalOpen: modalOpen,
          titleModal: typeAlert !== "error" ? "Success" : "Error",
          type: typeAlert,
          component: (
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{modalText}</p>
            </div>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              onClick: action,
              type: "primary",
            },
          ],
          onCancel: action,
        })}
        {createModal({
          isModalOpen: confirmCreate,
          component: (
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{modalText}</p>
            </div>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: () => this.setState({ confirmCreate: false }),
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: action,
              type: "primary",
            },
          ],
          onCancel: () => this.setState({ confirmCreate: false }),
        })}
      </ContentWrapper>
    );
  }
}

export default withNamespaces()(withRouter(withStyles(useStyles)(createUsers)));
